<template>
  <div class="login-wrapper pl-15 pr-15">
    <b-container>
      <b-row class="justify-content-center pt-40">
        <b-col
          col
          lg="4"
          md="7"
          cols="10"
          class="align-items-center text-center"
        >
          <h1 style="color:white;" class="text-center text-uppercase">
            {{ $t('text.authentication') }}
          </h1>
          <div class="text-center">
            <img
              src="../assets/security.png"
              class="w-50 img-fluid mx-auto image"
              alt="IMAGE"
            />
          </div>
          <div id="error">
            <p class="text-danger" v-show="IsError">
              {{ $t('text.invalid_credential') }}
            </p>
          </div>
          <b-form class="sign-in-form" @submit.prevent="TryLogin">
            <b-form-group id="input-group-username" label-for="Username">
              <b-form-input
                id="input-username"
                style="font-size:20px;"
                v-model.trim="username"
                type="text"
                v-bind:placeholder="$t('text.username')"
                :state="$v.username.$dirty ? !$v.username.$error : null"
                @blur="$v.username.$touch()"
              ></b-form-input>
              <div v-if="$v.username.$error">
                <p class="text-danger float-left" v-if="!$v.username.required">
                  {{ $t('text.username_required') }}
                </p>
              </div>
            </b-form-group>
            <b-form-group id="input-group-password" label-for="Password">
              <b-form-input
                id="input-password"
                style="font-size:20px;"
                v-model="password"
                type="password"
                v-bind:placeholder="$t('text.password')"
                :state="$v.password.$dirty ? !$v.password.$error : null"
                @blur="$v.password.$touch()"
              ></b-form-input>
              <div v-if="$v.password.$error">
                <p class="text-danger float-left" v-if="!$v.password.required">
                  {{ $t('text.password_required') }}
                </p>
              </div>
            </b-form-group>
            <b-button
              class="Sign-In-Button"
              type="submit"
              :disabled="$v.$invalid"
              >{{ $t('text.sign_in') | capitalize }}</b-button
            >
          </b-form>
          <div v-if="3 == 4" class="mt-3 text-right">
            <a href="#" style="color: white" class="text-lowercase">
              <u>{{ $t('text.forgot_password') }}</u>
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import NProgress from 'nprogress'
export default {
  name: 'login',
  data: function() {
    return {
      username: null,
      password: null,
      error: false
    }
  },
  methods: {
    TryLogin() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        this.$store
          .dispatch('user/login', {
            username: this.username,
            password: this.password
          })
          .then(
            () => {
              this.error = false
              if (
                this.$permission('Dashboard.Pod Accel.View') ||
                this.$permission('Dashboard.Pod Capacitance.View') ||
                this.$permission('Dashboard.Pod Data Stream.View')
              ) {
                this.$router.push({ path: '/' })
              } else if (
                this.$permission('Products.Manufacturers.View') ||
                this.$permission('Products.Product Description.View') ||
                this.$permission('Products.Product Characteristics.View') ||
                this.$permission('Products.Run.View') ||
                this.$permission('Products.Analyse Runs.View')
              ) {
                this.$router.push({ path: '/products' })
              } else if (
                this.$permission('Pods.Capacitance Readings Chart.View') ||
                this.$permission('Pods.Connection Status Chart.View') ||
                this.$permission('Pods.Battery Levels Chart.View') ||
                this.$permission('Pods.Accelerometer Readings Chart.View') ||
                this.$permission('Pods.Temperature Chart.View') ||
                this.$permission('Pods.SPO2 Chart.View') ||
                this.$permission('Pods.Calibration.View') ||
                this.$permission('Pods.Find Data.View') ||
                this.$permission('Pods.Diagnostics.View') ||
                this.$permission('Pods.Live Data.View')
              ) {
                this.$router.push({ path: '/pods' })
              } else if (this.$permission('Reports.Export CSV.Export')) {
                this.$router.push({ path: '/reports' })
              } else if (
                this.$permission('Production.Monitoring.View') ||
                this.$permission('Production.Test Reports.View') ||
                this.$permission('Production.Acceptance Criteria.View') ||
                this.$permission('Production.Firmware & Software.View')
              ) {
                this.$router.push({ path: '/production' })
              } else {
                this.$router.push({ path: '/manage' })
              }
            }
            // () => {
            //   this.error = false
            //   this.$router.push({ name: 'home' })
            // },
            // () => {
            //   this.error = true
            //   NProgress.done()
            // }
          )
          .catch(() => {
            this.error = true
            NProgress.done()
          })
      }
    }
  },
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  computed: {
    IsError() {
      return this.error
    },
    UsernameTest() {
      return this.username
    },
    PasswordTest() {
      return this.password
    }
  }
}
</script>

<style>
.Sign-In-Button {
  background: #8fcadd;
  width: 100%;
  border: 0;
  font-size: 20px;
}

.Sign-In-Button:hover,
.Sign-In-Button:focus {
  background: #629acf;
}

.image {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 60%;
  height: auto;
}

h1 {
  font-size: x-large;
  display: inline;
}

.error {
  color: #fa8072;
}
</style>
